import React from 'react';
import { Box, Typography, IconButton, Chip, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PercentIcon from '@mui/icons-material/Percent';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { radius } from '../../themes/smartinventoryTheme';

const buildCouponColumns = ({ t, isExpired, openEditWizard, openDeleteConfirm }) => [
  {
    field: 'code',
    headerName: t('Coupon Code'),
    flex: 1.3,
    minWidth: 160,
    renderCell: (params) => (
      <Chip
        icon={<LocalOfferIcon fontSize="small" />}
        label={params.value}
        size="small"
        sx={{
          bgcolor: (theme) => alpha(params.row.color || theme.palette.primary.main, 0.15),
          color: (theme) => params.row.color || theme.palette.primary.main,
          borderRadius: `${radius.sm}px`,
        }}
      />
    ),
  },
  {
    field: 'discount',
    headerName: t('Discount'),
    flex: 0.8,
    minWidth: 100,
    sortable: false,
    renderCell: (params) => (
      <Chip
        icon={params.row.discountType === 'PERCENT' ? <PercentIcon fontSize="small" /> : <AttachMoneyIcon fontSize="small" />}
        label={params.row.discountType === 'PERCENT' ? `${params.row.discountValue}%` : `$${params.row.discountValue}`}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'applicableProducts',
    headerName: t('Applies to'),
    flex: 0.9,
    minWidth: 110,
    sortable: false,
    renderCell: (params) => (
      <Typography variant="body2">
        {params.value.length === 0 ? t('All') : t('{{count}} products', { count: params.value.length, defaultValue: `${params.value.length} products` })}
      </Typography>
    ),
  },
  {
    field: 'eligibleUsers',
    headerName: t('Eligible users'),
    flex: 0.9,
    minWidth: 110,
    sortable: false,
    renderCell: (params) => (
      <Typography variant="body2">
        {params.value.length === 0 ? t('All') : t('{{count}} users', { count: params.value.length, defaultValue: `${params.value.length} users` })}
      </Typography>
    ),
  },
  {
    field: 'expiryDate',
    headerName: t('Expires'),
    flex: 0.9,
    minWidth: 120,
    renderCell: (params) => {
      if (!params.value) return <Chip label={t('Never')} size="small" color="success" variant="outlined" />;
      const expired = isExpired(params.value);
      return (
        <Typography variant="body2" color={expired ? 'error.main' : 'text.secondary'}>
          {new Date(params.value).toLocaleDateString()}
        </Typography>
      );
    },
  },
  {
    field: 'actions',
    headerName: '',
    width: 90,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Tooltip title={t('View')}>
          <IconButton size="small" onClick={() => openEditWizard(params.row)} aria-label={t('View')}>
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={t('Delete Coupon')}>
          <IconButton size="small" color="error" onClick={() => openDeleteConfirm(params.row)} aria-label={t('Delete Coupon')}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
];

export default buildCouponColumns;
